export default __webpack_public_path__ + "static/media/cleaner1.2fd1da07.jpg";